export const menuName = "用户运行指标";
export const menuList = [
  {
    key: "1",
    title: "概览",
    path: "/dashboard/operation-index/user-index/overview",
    src: require("@/assets/svg/icon/overview.svg"),
    checkedSrc: require("@/assets/svg/icon/overview-checked.svg")
  },
  {
    key: "2",
    title: "用户信息",
    path: "/dashboard/operation-index/user-index/info",
    src: require("@/assets/svg/icon/statistics.svg"),
    checkedSrc: require("@/assets/svg/icon/statistics.svg")
  }
];

export const INFO_TABLE_COLUMNS = [
  {
    title: "用户名称",
    dataIndex: "value1",
    key: "value1",
    ellipsis: true
  },
  {
    title: "联系方式",
    dataIndex: "value2",
    key: "value2",
    ellipsis: true
  },
  {
    title: "账号",
    dataIndex: "value3",
    key: "value3",
    ellipsis: true
  },
  {
    title: "用户来源",
    dataIndex: "value4",
    key: "value4",
    ellipsis: true
  },
  {
    title: "注册时间",
    dataIndex: "value5",
    key: "value5",
    ellipsis: true
  }
];
